import BaseAPI from './BaseAPI';

// Auth endpoints, namespaced under `/auth` (e.g. POST /auth/login).
// There is no public registration — user accounts are created by an admin via
// the AdminAPI (POST /auth/staff).
class AuthAPI extends BaseAPI {
  constructor() {
    super('auth');
  }

  async getUserInfo() {
    try {
      return await this.get('/whoami');
    } catch (error) {
      return null;
    }
  }

  async login(data) {
    try {
      return await this.post('/login', { body: data });
    } catch (error) {
      return { status: 'error', message: error?.message ?? 'Login Failed' };
    }
  }

}

export const AuthService = new AuthAPI();
export default AuthAPI;
